(function () {
  function parseDims(str) {
    if (!str) return null;
    const s = String(str).toLowerCase().replace(/cm/g, '').replace(/\s+/g, ' ').trim();
    const m = s.match(/(\d+)\s*[x×]\s*(\d+)/);
    if (!m) return null;
    const a = parseFloat(m[1]), b = parseFloat(m[2]);
    if (Number.isNaN(a) || Number.isNaN(b)) return null;
    return { l: a, w: b };
  }

  function buildVariants(raw) {
    const out = [];
    (raw || []).forEach(v => {
      const d = parseDims(v.title) || parseDims(v.option1);
      if (!d) return;
      out.push({ id: v.id, title: v.title, l: d.l, w: d.w, available: v.available });
    });
    return out;
  }

  function bestFit(reqL, reqW, vars) {
    const areaReq = reqL * reqW;
    let best = null, bestExcess = Infinity;

    const ordered = [...vars].sort((a,b) => (b.available === a.available ? 0 : (a.available ? -1 : 1)));

    for (const v of ordered) {
      const ok1 = v.l >= reqL && v.w >= reqW;
      const ok2 = v.l >= reqW && v.w >= reqL; // rotación
      if (!ok1 && !ok2) continue;

      const excess = (v.l * v.w) - areaReq;
      if (excess >= 0 && excess < bestExcess) {
        best = v; bestExcess = excess;
      }
    }

    if (!best) {
      let max = null, maxArea = -1;
      for (const v of ordered) {
        const a = v.l * v.w;
        if (a > maxArea) { maxArea = a; max = v; }
      }
      best = max;
    }
    return best;
  }

  function selectVariant(id) {
    const idStr = String(id);
    const radio = document.querySelector(`input[name="id"][value="${idStr}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const sel = document.querySelector('select[name="id"]');
    if (sel) {
      sel.value = idStr;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('[data-mantel-modal]');
    if (!modal) return;

    const openBtn = document.querySelector('[data-mantel-open]');
    const closeBtns = document.querySelectorAll('[data-mantel-close]');
    const calcBtn = document.querySelector('[data-mantel-calc]');
    const result = document.querySelector('[data-mantel-result]');

    const forma = document.getElementById('drgz-forma');
    const ancho = document.getElementById('drgz-ancho');
    const largo = document.getElementById('drgz-largo');
    const fieldLargo = document.querySelector('[data-field-largo]');
    const labelAncho = document.querySelector('[data-label-ancho]');
    const caida = document.getElementById('drgz-caida');

    const productId = Object.keys(window.DecorugzMantelVariants || {})[0];
    const raw = (window.DecorugzMantelVariants && window.DecorugzMantelVariants[productId]) || [];
    const vars = buildVariants(raw);

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    openBtn?.addEventListener('click', open);
    closeBtns.forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    forma?.addEventListener('change', () => {
      if (forma.value === 'redonda') {
        fieldLargo.style.display = 'none';
        labelAncho.textContent = 'Diámetro de la mesa (cm)';
      } else {
        fieldLargo.style.display = '';
        labelAncho.textContent = 'Ancho de la mesa (cm)';
      }
    });

    calcBtn?.addEventListener('click', () => {
      const f = forma.value;
      const drop = parseFloat(caida.value);

      let mesaL, mesaW;
      if (f === 'redonda') {
        const d = parseFloat(ancho.value);
        if (!d || d <= 0) { result.innerHTML = `<p style="color:#b91c1c;">Ingresa el diámetro de tu mesa.</p>`; return; }
        mesaL = d; mesaW = d;
      } else {
        mesaW = parseFloat(ancho.value);
        mesaL = parseFloat(largo.value);
        if (!mesaL || !mesaW || mesaL <= 0 || mesaW <= 0) { result.innerHTML = `<p style="color:#b91c1c;">Ingresa ancho y largo en cm.</p>`; return; }
      }

      if (!vars.length) { result.innerHTML = `<p style="color:#b91c1c;">No se detectaron variantes con formato 200x155.</p>`; return; }

      const reqL = mesaL + 2 * drop;
      const reqW = mesaW + 2 * drop;
      // Si ninguna variante alcanza el tamaño requerido, mostrar mensaje y no recomendar
const hasFit = vars.some(v => {
  const ok1 = v.l >= reqL && v.w >= reqW;
  const ok2 = v.l >= reqW && v.w >= reqL; // permite rotación
  return ok1 || ok2;
});

if (!hasFit) {
  const mesaTxtFail = (f === 'redonda')
    ? `una mesa redonda de <span class="drgz-strong">${mesaW} cm</span> de diámetro`
    : `una mesa ${f} de <span class="drgz-strong">${mesaW}×${mesaL} cm</span>`;

  result.innerHTML = `
    <div class="drgz-card">
      <h3>No disponemos de manteles para ${mesaTxtFail}.</h3>
      <p>Prueba con una caída menor o escríbenos para ayudarte.</p>
    </div>
  `;
  return;
}


      const best = bestFit(reqL, reqW, vars);
      if (!best) { result.innerHTML = `<p style="color:#b91c1c;">No encontramos una medida adecuada.</p>`; return; }

      const mesaTxt = (f === 'redonda')
        ? `mesa redonda de <span class="drgz-strong">${mesaW} cm</span> de diámetro`
        : `mesa ${f} de <span class="drgz-strong">${mesaW}×${mesaL} cm</span>`;

      result.innerHTML = `
        <div class="drgz-card">
          <div class="drgz-badge">${f.toUpperCase()}</div>
          <h3>✓ Tamaño recomendado</h3>
          <p>Para tu ${mesaTxt} con una caída de <span class="drgz-strong">${drop} cm</span>:</p>
          <p>Te recomendamos el mantel <span class="drgz-strong">${best.l}×${best.w} cm</span>.</p>
        </div>
      `;

      selectVariant(best.id);
    });
  });
})();
